const detectedBasePath = (() => {
  if (typeof window === "undefined") return "";

  const configured = window.__KALOPSIA_SIMPLEBI_BASE_PATH__;
  if (typeof configured === "string") {
    return configured.replace(/\/$/, "");
  }

  const pathname = window.location.pathname;
  return pathname === "/simplebi" || pathname.startsWith("/simplebi/")
    ? "/simplebi"
    : "";
})();

export const APP_BASE_PATH = detectedBasePath;

export const API_ORIGIN = (() => {
  if (typeof window === "undefined") return "";

  const configured = window.__KALOPSIA_SIMPLEBI_API_ORIGIN__;
  if (typeof configured === "string" && configured.trim()) {
    return configured.replace(/\/$/, "");
  }

  const hostname = window.location.hostname;

  if (hostname === "demo.kalopsia.pro") {
    return window.location.origin;
  }

  if (
    hostname === "cartofisserie.kalopsia.pro" ||
    hostname.endsWith(".cartofisserie.ro")
  ) {
    return "https://cartofisserie.kalopsia.pro";
  }

  return "https://rapoarte.kalopsia.pro";
})();
